const moduleName = 'countdown';

export function countdown() {

    Array.from(document.querySelectorAll('.js-countdown')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const countdown = self;
        const countdownDays = countdown.querySelector('.js-countdown-days');
        const countdownHours = countdown.querySelector('.js-countdown-hours');
        const countdownMinutes = countdown.querySelector('.js-countdown-minutes');
        const countdownSeconds = countdown.querySelector('.js-countdown-seconds');
        const countdownDaysLabel = countdown.querySelector('.js-countdown-days-label');
        const countdownHoursLabel = countdown.querySelector('.js-countdown-hours-label');
        const countdownMinutesLabel = countdown.querySelector('.js-countdown-minutes-label');
        const countdownSecondsLabel = countdown.querySelector('.js-countdown-seconds-label');
        const countdownEndtime = countdown.dataset.date;

        const timeinterval = setInterval(() => {
            const t = getTimeRemaining(countdownEndtime);

            if (t.total <= 0) {
                clearInterval(timeinterval);

                countdownDays.innerHTML = '0';
                countdownHours.innerHTML = '00';
                countdownMinutes.innerHTML = '00';
                countdownSeconds.innerHTML = '00';
                countdownDaysLabel.innerHTML = 'дней';
                countdownHoursLabel.innerHTML = 'часов';
                countdownMinutesLabel.innerHTML = 'минут';
                countdownSecondsLabel.innerHTML = 'секунд';

            } else {
                countdownDays.innerHTML = t.days;
                countdownHours.innerHTML = ('0' + t.hours).slice(-2);
                countdownMinutes.innerHTML = ('0' + t.minutes).slice(-2);
                countdownSeconds.innerHTML = ('0' + t.seconds).slice(-2);
                countdownDaysLabel.innerHTML = 'д' + getEnding(t.days, ['ень', 'ня', 'ней']);
                countdownHoursLabel.innerHTML = 'час' + getEnding(t.hours, ['', 'а', 'ов']);
                countdownMinutesLabel.innerHTML = 'минут' + getEnding(t.minutes, ['а', 'ы', '']);
                countdownSecondsLabel.innerHTML = 'секунд' + getEnding(t.seconds, ['а', 'ы', '']);
            }
        }, 1000);



        function getTimeRemaining(endtime){
            const t = Date.parse(endtime) - Date.parse(new Date());
            const seconds = Math.floor( (t/1000) % 60 );
            const minutes = Math.floor( (t/1000/60) % 60 );
            const hours = Math.floor( (t/(1000*60*60)) % 24 );
            const days = Math.floor( t/(1000*60*60*24) );

            return {
                'total': t,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds
            };
        }

        function getEnding(number, endings) {
            var lastDigits = number.toString().substr(-2, 2);
            var lastDigit = lastDigits.substr(-1, 1);

            if (+lastDigits >= 11 && +lastDigits <= 14) {
                return endings[2];
            } else if (lastDigit == 1) {
                return endings[0];
            } else if (+lastDigit >= 2 && +lastDigit <= 4) {
                return endings[1];
            } else {
                return endings[2];
            }
        }
    });

}